import * as React from "react";
import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Typography from "@mui/material/Typography";
import CloseIcon from "@mui/icons-material/Close";
import axios from "axios";
import { CircularProgress } from "@mui/material";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

export default function CustomDialog({ open, handleClose, image, title }) {
  const [loading, setLoading] = React.useState(false);
  const handleSaveToDesktop = () => {
    setLoading(true); // Start loading

    const proxyUrl =
      "https://proxy-iota-ten.vercel.app/proxy?url=" +
      encodeURIComponent(image);

    axios
      .get(proxyUrl, { responseType: "blob" }) // Ensure binary response
      .then((response) => {
        // Create a URL for the blob
        const blobUrl = URL.createObjectURL(response.data);

        // Create a download link
        const link = document.createElement("a");
        link.href = blobUrl;
        link.setAttribute("download", "downloaded_image.jpg");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        // Revoke the blob URL after download
        setTimeout(() => URL.revokeObjectURL(blobUrl), 100);
      })
      .catch((error) => console.error("Error downloading image:", error))
      .finally(() => {
        setLoading(false); // Stop loading
      });
  };

  return (
    <BootstrapDialog
      onClose={handleClose}
      aria-labelledby="customized-dialog-title"
      open={open}
    >
      <CloseIcon
        aria-label="close"
        onClick={handleClose}
        sx={{
          cursor: "pointer",
          padding: "8px",
          display: "flex",
          justifyContent: "flex-end",
          alignSelf: "end",
          color: (theme) => theme.palette.grey[500],
        }}
      />
      <DialogContent sx={{ paddingBottom: "0px !important" }}>
        <img
          height={{ md: "500px", sm: "300px" }}
          style={{
            objectFit: "contain",
          }}
          width="100%"
          src={image}
          alt={title}
        />
        <Typography variant="h6">{title}</Typography>
      </DialogContent>
      <DialogActions
        sx={{
          justifyContent: "flex-start",
        }}
      >
        <Button
          variant="contained"
          onClick={handleSaveToDesktop}
          sx={{
            backgroundColor: "#333",
            "&:hover": {
              backgroundColor: "#333",
            },
            flex: 1,
            marginBottom: "8px",
            ml: "8px",
          }}
        >
          {loading ? (
            <CircularProgress sx={{ color: "#fff" }} size={24} />
          ) : (
            "Save to Desktop"
          )}{" "}
        </Button>
      </DialogActions>
    </BootstrapDialog>
  );
}
